export default __webpack_public_path__ + "static/media/oriental.4124b85d.png";